import { Component,ViewChild,ViewEncapsulation} from '@angular/core';
import {AgmMap, MapsAPILoader  } from '@agm/core';
// import { } from '@types/googlemaps';

@Component({
  selector: 'app-location-test',
  templateUrl: './location-test.component.html',
  styleUrls: ['./location-test.component.scss']
})
export class LocationTestComponent {
  title = 'AGMMapAngular';
  @ViewChild(AgmMap,{static: true}) public agmMap: AgmMap;
  zoom: any;
  lat: any;
  lng: any;
  getAddress: any;
  longitude: any;
  latitude: any;
  currentLocation:string;
  markers: any;
  
  constructor(
    private apiloader:MapsAPILoader
  )
{
 
}
  ngOnInit()
  {
    this.get();
    this.agmMap.triggerResize(true);
     this.zoom = 16;
    }
get(){
   debugger

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function(position) {
      if (position) {
        console.log(position)
      // this.lat = position.coords.latitude;
      // this.lng = position.coords.longitude;
      var lats = position.coords.latitude;
      var lngs = position.coords.longitude;
      //this.lat = 
      console.log("Lattitude is "+ lats + " longitude is " + lngs);
    //   this.getAddress=(this.lats,this.lngs)
    //let location = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

       this.apiloader.load().then(() => {
         let geocoder = new google.maps.Geocoder;
         let latlng = {lat: lats, lng: lngs};
       
         geocoder.geocode({'location': latlng}, function(results) {
             if (results[0]) {
               this.currentLocation= results[0].formatted_address;
             
             console.log(this.currentLocation);
             } else {
               console.log('Not found');
            }

        
         });
     });


    }
  })
}

}

mapClicked($event: google.maps.MouseEvent) {

  this.markers.push({
    lat: $event.latLng.lat(),
    lng: $event.latLng.lng(),
    draggable: true
  });
  // this.latitude= $event.coords.lat,
  // this.longitude= $event.coords.lng

  
  this.apiloader.load().then(() => {
    let geocoder = new google.maps.Geocoder;
    let latlng = {lat: this.latitude, lng: this.longitude};
  
    geocoder.geocode({'location': latlng}, function(results) {
        if (results[0]) {
          this.currentLocation = results[0].formatted_address;
        console.log(this.currentLocation);
        } else {
          console.log('Not found');
        }
    });
  });
}


}
